module.exports = __webpack_public_path__ + "img/bl-active.b5572fd1.png";